import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { hasAnyModule } from "../../moduleaccessLogic";
import Inventory from "../inventory/inventory";
import TableeOrders from "../tablee/TableeOrders";
import { CATALOG_MODULES, INVENTORY_MODULES } from "./productWorkspaceAccess";
import "./productWorkspace.css";

export default function ProductWorkspace() {
  const [params, setParams] = useSearchParams();
  const [catalogActionsTarget, setCatalogActionsTarget] = useState(null);
  const modules = localStorage.getItem("userModules");
  const canCatalog = hasAnyModule(modules, CATALOG_MODULES);
  const canInventory = hasAnyModule(modules, INVENTORY_MODULES);
  const tabs = [
    ...(canCatalog ? [{ id: "catalog", label: "Eventos" }] : []),
    ...(canInventory ? [{ id: "inventory", label: "Minimarket" }] : []),
  ];
  const activeTab = tabs.find((tab) => tab.id === params.get("tab"))?.id || tabs[0]?.id;
  const [visited, setVisited] = useState(() => [activeTab]);
  useEffect(() => {
    setVisited((current) => current.includes(activeTab) ? current : [...current, activeTab]);
  }, [activeTab]);

  const selectTab = (tab, sku) => {
    const next = new URLSearchParams(params);
    next.set("tab", tab);
    if (sku !== undefined) next.set("q", sku);
    setParams(next);
  };
  const handleTabKeyDown = (event, index) => {
    if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return;
    event.preventDefault();
    const next = event.key === "Home" ? 0 : event.key === "End" ? tabs.length - 1
      : (index + (event.key === "ArrowRight" ? 1 : -1) + tabs.length) % tabs.length;
    selectTab(tabs[next].id);
    event.currentTarget.parentElement.querySelectorAll('[role="tab"]')[next].focus();
  };

  return (
    <div className="product-workspace">
      <header className="product-workspace__header">
        <div className="product-workspace__title">
          <span>Catálogo compartido · Operaciones</span>
          <h1>Productos y arriendos</h1>
          <p>Administra la publicación en tiendas y el inventario por ubicación desde un mismo lugar.</p>
        </div>
        {canCatalog ? <div className="product-workspace__actions" ref={setCatalogActionsTarget} hidden={activeTab !== "catalog"} /> : null}
      </header>
      <div className="product-workspace__tabs" role="tablist" aria-label="Gestión de productos y arriendos">
        {tabs.map((tab, index) => (
          <button key={tab.id} id={`product-tab-${tab.id}`} type="button" role="tab"
            aria-selected={activeTab === tab.id} aria-controls={`product-panel-${tab.id}`}
            tabIndex={activeTab === tab.id ? 0 : -1} onClick={() => selectTab(tab.id)}
            onKeyDown={(event) => handleTabKeyDown(event, index)}>
            {tab.label}
          </button>
        ))}
      </div>
      {canCatalog ? <section className="product-workspace__panel" id="product-panel-catalog" role="tabpanel"
        aria-labelledby="product-tab-catalog" hidden={activeTab !== "catalog"}>
        {visited.includes("catalog") ? <TableeOrders embedded active={activeTab === "catalog"} headerActionsTarget={catalogActionsTarget}
          onManageInventory={canInventory ? (product) => selectTab("inventory", product.sku || "") : undefined} /> : null}
      </section> : null}
      {canInventory ? <section className="product-workspace__panel" id="product-panel-inventory" role="tabpanel"
        aria-labelledby="product-tab-inventory" hidden={activeTab !== "inventory"}>
        {visited.includes("inventory") ? <Inventory embedded active={activeTab === "inventory"} searchQuery={params.get("q") ?? undefined} /> : null}
      </section> : null}
    </div>
  );
}
